var styleDataHash = "00498daa";
const injectCss = (() => {
  var css = `.ZGC4R{display:block!important;margin:0}video::-webkit-media-controls{opacity:1;transition:opacity .3s ease}.XiGKY video::-webkit-media-controls{opacity:.2}._3qqBf{width:min(100%,var(--ricos-internal-resize-width,var(--ricos-internal-figure-width,initial)))}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var figure_default = {
  "figure": "ZGC4R",
  "figureWithCaption": "XiGKY",
  "figureContainer": "_3qqBf"
};
export {
  figure_default as default,
  injectCss
};
//# sourceMappingURL=figure-scss.js.map
